import { Component, Input } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormEntryResponse } from '../../../../models/responses/form-entry-response';
import { NgFor } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';


export const FIELD_NAME_VALIDATOR = [Validators.required, Validators.maxLength(25), Validators.pattern('^[a-zA-Z0-9 ]*$')]
export const FIELD_KEY_VALIDATOR = [Validators.required, Validators.pattern('^[a-zA-Z_][a-zA-Z0-9_]*$')]
export const FIELD_DESCRIPTION_VALIDATOR = [Validators.required]
@Component({
  selector: 'app-form-entries',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    NgFor,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
  ],
  templateUrl: './form-entries.component.html',
  styleUrl: './form-entries.component.scss'
})
export class FormEntriesComponent {

  @Input() formEntries!: FormEntryResponse[];
  @Input() formEntryForm!: FormGroup
  dataTypes = [
    "string",
    "number",
    "boolean"
  ]
  constructor(
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.formEntryForm.addControl('fields', this.formBuilder.array([]))
    if (this.formEntries) {
      this.initFormEntries();
    }
  }



  get fields(): FormArray<FormGroup> {
    return this.formEntryForm.controls['fields'] as FormArray<FormGroup>;
  }

  initFormEntries() {
    this.formEntries.forEach(entry => {
      this.fields.push(this.formBuilder.group({
        id: [entry.id, Validators.required],
        fieldName: [entry.fieldName, FIELD_NAME_VALIDATOR],
        fieldDescription: [entry.fieldDescription, FIELD_DESCRIPTION_VALIDATOR],
        fieldType: [entry.fieldType,Validators.required],
        fieldKey: [entry.fieldKey, FIELD_KEY_VALIDATOR]
      }));
    });
  }
  onAddField() {
    this.fields.push(this.formBuilder.group({
      id: [''],
      fieldName: ['', FIELD_NAME_VALIDATOR],
      fieldDescription: ['', FIELD_DESCRIPTION_VALIDATOR],
      fieldType:['',Validators.required],
      fieldKey: ['', FIELD_KEY_VALIDATOR]
    }));
  }

  onRemoveField(index: number) {
    this.fields.removeAt(index);
  }
}

